import { canCallAuthenticatedApi, getBusinessId } from './Api';
import useBusinessPostApi from './useBusinessPostApi.js';
import usePublicPostApi from '../public/lib/usePublicPostApi.js';

export default function (route) {
    if (canCallAuthenticatedApi()) {
        return useBusinessPostApi(route);
    } else {
        return usePublicPostApi(route);
    }
}
